import type { AnalyticalDatasetDefinitionStoreState } from './types';

export const selectLoadedVersionId = (state: AnalyticalDatasetDefinitionStoreState) =>
  state.loadedVersionId;

export const selectCohorts = (state: AnalyticalDatasetDefinitionStoreState) => state.cohorts;

export const selectVariables = (state: AnalyticalDatasetDefinitionStoreState) => state.variables;

export const selectHasStagedChanges = (state: AnalyticalDatasetDefinitionStoreState) =>
  state.hasStagedChanges;
